<template>
  <div @mouseleave="onMouseLeave" @mouseover="onMouseOver">
    <clouded-glass class="content">
      <div slot="content">
        <div class="text-lightBlue font-weight-bold" style="position: relative">
          {{ item.name }}
          <i v-show="showBtn" @touchstart="edit" @click="edit"
             ref="btnEdit"
             class="el-icon-edit text-blue pointer"
             style="position: absolute;right: 20px;top: 5px"></i>
          <i v-show="showBtn" @touchstart="deviceLinkDelete" @click="deviceLinkDelete"
             ref="btnDelete"
             class="el-icon-close text-red font-weight-bold pointer"
             style="position: absolute;right: 0;top: 5px"></i>
        </div>
        <div style="display:flex;margin: 20px 0 10px 10px;align-items: center">
          <div style="flex-basis: 90px;border-right: 1px dashed rgba(255,255,255,.2)">
            <name-icon title="复杂" v-if="isComplex"></name-icon>
            <name-icon title="简单" v-else></name-icon>
            <div class="text-center margin-top-10" style="font-size: 0.9rem"
                 :style="{visibility:isComplex?'none':'hidden'}">
              {{
                item.deviceLinkageActiviti && item.deviceLinkageActiviti.deviceTypeName ? item.deviceLinkageActiviti.deviceTypeName : ''
              }}{{ item.deviceLinkageActiviti && item.deviceLinkageActiviti.deviceName }}触发
            </div>
          </div>
          <div style="padding-left: 15px">
            <div>
              <span>状态：</span>
              <el-switch
                :value="item.isEnable"
                @touchstart.native="deviceLinkSwitch"
                @click.native="deviceLinkSwitch"
                active-text="开启"
                active-color="#13ce66"
                inactive-color="#ff4949"
                inactive-text="关闭">
              </el-switch>
            </div>
            <div class="margin-top-10" :style="{visibility:isComplex?'none':'hidden'}">
              <span>流程：</span>
              <span
                class="text-blue">{{
                  item.deviceLinkageActiviti && item.deviceLinkageActiviti.procName ? item.deviceLinkageActiviti.procName : ''
                }} V{{
                  item.deviceLinkageActiviti && item.deviceLinkageActiviti.procVersion ? item.deviceLinkageActiviti.procVersion : ''
                }}.0</span>
            </div>
          </div>
        </div>
        <div class="text-blue text-right">
          <i @touchstart="viewLogs" @click="viewLogs"
             class="el-icon-view pointer">
            <span class="margin-left-5">查看联动记录</span>
          </i>
        </div>
      </div>
    </clouded-glass>
  </div>
</template>

<script>
import {deviceLinkDelete, deviceLinkSwitch} from '@/network/device-linkage';
import NameIcon from "@/components/style/NameIcon";
import CloudedGlass from "@/components/style/CloudedGlass";

export default {
  name: "LinkageListItem",
  components: {NameIcon, CloudedGlass},
  props: ["item"],
  data() {
    return {
      showBtn: false,
      enable: false,
      isComplex: true
    }
  },
  mounted() {
    // 是否为复杂策略 true 是 false 不是
    this.isComplex = this.item.type === 1;
  },
  methods: {
    edit() {
      if (!this.isComplex) {
        this.$router.push({name: '联动策略编辑', query: {id: this.item.id}});
      } else {
        this.$emit('receiveMode', 'complex');
        // setEditDta
        this.$emit('setEditDta', this.item);
        this.$emit('openDialog', 'two');
      }
    },
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    deviceLinkSwitch() {
      let switchLabel = !this.item.isEnable ? '启用' : '关闭';
      this.$confirm('是否确认' + switchLabel + "该联动策略", {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            // 执行保存
            deviceLinkSwitch(this.item.id, !this.item.isEnable).then(res => {
              console.log(res);
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.item.isEnable = !this.item.isEnable
              } else {
                this.$message.error('操作失败');
              }
            });
          }
        }
      })
    },
    deviceLinkDelete() {
      this.$confirm('是否确认删除该联动策略', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            // 执行删除
            deviceLinkDelete(this.item.id).then(res => {
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.$emit("getLinkageList");
              } else {
                this.item.isEnable = !this.item.isEnable;
                this.$message.error('操作失败');
              }
            });
          }
        }
      })
    },
    viewLogs() {
      // isComplex 是不是复杂策略
      this.$emit('setEditDta', this.item);
      this.$emit('openDialog', this.isComplex ? 'logs' : 'actionLogs');

      // 复杂策略
      // this.$router.push({path: '/strategy/linkage-log-list', query: {item: this.item}});

    }
  }
}
</script>

<style scoped>
.content {
  width: 380px;
  height: 200px;
  padding: 20px 25px 20px 25px;
}

.hidden.btn {
  flex: inherit;
}

.hidden.btn:hover {
  cursor: pointer;
}

.btn-edit {
  margin: 0 0 0 37px;
}

.btn-delete {
  margin: 0 0 0 115px;
}

/*图标*/
.logo.img {
  margin: 50px 0 0 103px;
  width: 58px;
  height: 50px;
}

</style>
